// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__AcWGP","container":"Footer_container__fvqaJ","itensFooter":"Footer_itensFooter__Ra8CB","item":"Footer_item__Dn+YQ","creditos":"Footer_creditos__ydP8W"};